import { render, staticRenderFns } from "./StudentElectives.vue?vue&type=template&id=75977fa6&scoped=true"
import script from "./StudentElectives.vue?vue&type=script&lang=js"
export * from "./StudentElectives.vue?vue&type=script&lang=js"
import style0 from "./StudentElectives.vue?vue&type=style&index=0&id=75977fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75977fa6",
  null
  
)

export default component.exports